const sceneTemplateFour = {
  id: 11,
  uid: '75129542-0e04-41a4-9dcd-5d207ca7055c',
  name: 'This One',
  scene_name: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
  ingested: false,
  description: 'CanvasPro Template created from Template4',
  svars: {},
  conditions: {
    play_conditions: [],
    timestamp: 1708597538,
  },
  priority: 1,
  enabled: true,
  conditions_edited: false,
  domination_mode: 0,
  triggers: [],
  type: 'video_scene',
  did: 26,
  pdid: 4,
  live: false,
  ch_did: 1,
  item_type: 3,
  valid: true,
};

const templateFour = {
  id: 10,
  uid: 'c097b3d1-a65f-415e-bd6c-a45243150f55',
  description: 'CanvasPro Template created from Template4',
  name: 'template4',
  multi: false,
  display_name: 'Template4',
  scene_data: {},
  hidden: false,
  timestamp: 1708597538,
  icon: 'mdi-cube-outline',
  src_file: 'Template4.vza',
  extra_info: {
    nested_template: true,
  },
  src_scene_data: {
    '$Top Left': {
      name: '$Top Left',
      port_index: 0,
      label: 'Top Left',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Top Right': {
      name: '$Top Right',
      port_index: 1,
      label: 'Top Right',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Bottom Left': {
      name: '$Bottom Left',
      port_index: 2,
      label: 'Bottom Left',
      type: 'ventuz_scene_layer',
      value: null,
    },
    '$Bottom Right': {
      name: '$Bottom Right',
      port_index: 3,
      label: 'Bottom Right',
      type: 'ventuz_scene_layer',
      value: null,
    },
  },
  files: [],
  thumbnail:
    'data:image/jpeg;base64, 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',
  status: 2,
  default_conditions: [],
  default_triggers: [],
  color: 'rgb(23,23,23)',
  dynamic_preload: false,
  revision: 0,
  tags: [],
  default_template: false,
};

const templateOne = {
  id: 19,
  extra_info: {
    nested_template: true,
  },
  uid: '0c4dd3a5-fb35-49b6-8ec8-fb2c827f95ed',
  description: 'CanvasPro Template created from TemplateOne',
  name: 'templateOne',
  multi: false,
  display_name: 'Template One',
  scene_data: {},
  hidden: false,
  timestamp: 1708597538,
  icon: 'mdi-cube-outline',
  src_file: 'TemplateOne.vza',
  src_scene_data: {
    $MyOnlyPort: {
      name: '$MyOnlyPort',
      port_index: 0,
      label: 'My Only Port',
      type: 'ventuz_scene_layer',
      value: null,
    },
  },
  files: [],
  thumbnail:
    'data:image/jpeg;base64, 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',
  status: 2,
  default_conditions: [],
  default_triggers: [],
  color: 'rgb(23,23,23)',
  dynamic_preload: false,
  revision: 0,
  tags: [],
  default_template: false,
};

const sceneTemplateOne = {
  id: 87,
  uid: 'fee10d0c-b975-4c3f-b05f-6f5d568ec050',
  name: 'This One',
  scene_name: '0c4dd3a5-fb35-49b6-8ec8-fb2c827f95ed',
  ingested: false,
  description: 'CanvasPro Template created from TemplateOne',
  svars: {},
  conditions: {
    play_conditions: [],
    timestamp: 1708597538,
  },
  priority: 1,
  enabled: true,
  conditions_edited: false,
  domination_mode: 0,
  triggers: [],
  type: 'video_scene',
  did: 26,
  pdid: 4,
  live: false,
  ch_did: 1,
  item_type: 3,
  valid: true,
};

function addSvarsToTemplateFour(scene) {
  const copyOfScene = JSON.parse(JSON.stringify(scene));
  copyOfScene.svars = {
    '$Bottom Left': {
      type: 'ventuz_scene_layer',
      value: 'from_template',
      scene_data: {},
    },
    '$Bottom Right': {
      type: 'ventuz_scene_layer',
      value: 'from_template',
      scene_data: {},
    },
    '$Top Left': {
      type: 'ventuz_scene_layer',
      value: 'from_template',
      scene_data: {},
    },
    '$Top Right': {
      type: 'ventuz_scene_layer',
      value: 'from_template',
      scene_data: {},
    },
  };

  return copyOfScene;
}

function addNestedTemplateAndSpinnyCubesToSvars(scene) {
  //   console.log('scene: ', scene);
  const copyOfSceneData = JSON.parse(JSON.stringify(scene));

  const nestedTemplateUid = 'c097b3d1-a65f-415e-bd6c-a45243150f55';
  const spinnyCubeUid = '6d91620e-e732-4226-a8c2-2b93f98bc3bc';

  const spinnyCubeSceneData = {
    '.ColorValue': { value: 'from_scene', type: 'color' },
    '.File': { value: 'from_scene', type: 'asset' },
  };

  const levels = ['$Bottom Left', '$Bottom Right', '$Top Right', '$Top Left'];

  for (const level of levels) {
    if (!copyOfSceneData.svars[level]) copyOfSceneData.svars[level] = {};
    copyOfSceneData.svars[level]['scene_data'] = {};
    copyOfSceneData.svars[level]['value'] = nestedTemplateUid;
    copyOfSceneData.svars[level]['type'] = 'ventuz_scene_layer';

    for (const level2 of levels) {
      copyOfSceneData.svars[level]['scene_data'][level2] = {
        scene_data: spinnyCubeSceneData,
        value: spinnyCubeUid,
        type: 'ventuz_scene_layer',
      };
    }
  }

  return copyOfSceneData;
}

const expandTemplateFour =
  addNestedTemplateAndSpinnyCubesToSvars(sceneTemplateFour);

const sceneT4WithSvars = addSvarsToTemplateFour(sceneTemplateFour);

// console.dir(expandTemplateFour.svars, { depth: null });

export default {
  sceneTemplateFour,
  expandTemplateFour,
  templateFour,
  sceneT4WithSvars,
  templateOne,
  sceneTemplateOne,
};
